export default __webpack_public_path__ + "static/media/avatar_55.1f3b45ab.png";